<template>
  <div class="mail-ueditor">
    <!--editor的div为富文本的承载容器-->
    <div :id="idForEditor" type="text/plain" class="mail-ueditor-main" style="width:100%;height:360px;"></div>
    <input type="file" class="teamface-ueditor" accept="image/*" @change="getFiles($event)">
  </div>
</template>

<script>
import {HTTPServer} from '@/common/js/ajax.js'
import tool from '@/common/js/tool.js'

export default {
  name: 'mailUeditor',
  // editorContent 富文本内容
  // isEdit 是否可编辑 false 只读 true 可编辑
  props: ['editorContent', 'isEdit', 'maximumWords', 'moduleId', 'minH'],
  data () {
    return {
      editorContentProp: this.editorContent,
      idForEditor: 'editor' + new Date().getTime(), // id为唯一值可避免二次渲染不显示的问题
      editor: null,
      minHeight: this.minH || '460px',
      // minHeight: '570px',
      newImgSrc: '',
      newImg: '',
      config: {
        toolbars: [
          ['customstyle', 'paragraph', 'fontfamily', 'fontsize', '|', 'directionalityltr', 'directionalityrtl', 'indent', '|', 'undo', 'redo', 'simpleupload', 'bold', 'italic', 'underline', 'fontborder', 'forecolor', 'backcolor', 'formatmatch', 'blockquote', 'pasteplain', '|',
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|', 'strikethrough', 'removeformat', 'insertorderedlist', 'insertunorderedlist', 'selectall', '|',
            'link', 'unlink', 'anchor', '|', 'horizontal', 'date', 'time', 'spechars', '|', 'print', 'preview', 'searchreplace', 'help', 'fullscreen']
        ],
        // 列表排序类型选择
        insertorderedlist: {
          'decimal': '',
          'lower-alpha': '',
          'lower-roman': '',
          'upper-alpha': '',
          'upper-roman': ''
        },
        fontsize: [10, 11, 12, 14, 16, 18, 20, 24, 36],
        elementPathEnabled: false, // 是否显示编辑器最后一行
        maximumWords: this.maximumWords || 10000, // 字数限制
        initialFrameHeight: this.minH || 320,
        wordCount: false,
        allowDivTransToP: false,
        enableAutoSave: false, // 禁止自动保存
        saveInterval: 999999, // 自动保存时间间隔
        BaseUrl: '',
        UEDITOR_HOME_URL: '/static/YS-frame/UE/',
        autoHeightEnabled: false,
        imageScaleEnabled: false,
        disabledTableInTable: false, // 不禁止表格嵌套
        autoSyncData: false, // 自动同步编辑器要提交的数据
        focus: false,
        autoClearinitialContent: '请输入' // 默认值
      }
    }
  },
  mounted () {
    if (this.moduleId === 19) {
      this.config.toolbars = [['link']]
    } else if (this.moduleId.includes('multi_')) {
      this.config.toolbars = [['link']]
    }
    // 实例化editor编辑器
    let _this = this
    _this.createUe()
    // this.YS.YS_ueditor(_this.createUe)
    // 清空编辑器
    this.$bus.off('resetEditor')
    this.$bus.on('resetEditor', value => {
      if (value) {
        this.editor.setContent('')
      }
    })

    this.$bus.off('file-basc64')
    this.$bus.on('file-basc64', value => {
      // console.log(value, '粘贴图片的方法')
    })
  },
  methods: {
    // 上传图片-获取文件流
    getFiles (event) {
      // 获取文件流
      let formdata = new FormData()
      formdata.append('file', event.target.files[0])
      event.target.value = ''
      // 上传文件,获取路径
      HTTPServer.imageUpload(formdata).then((res) => {
        // 生成一个img,追加到富文本内容
        window.UE.getEditor(this.idForEditor).focus()
        // 这个方法可以实现设置图片大小，如果需要可以写个弹窗设置宽高实现 todo
        window.UE.getEditor(this.idForEditor).execCommand('insertimage', {
          src: res[0].file_url
          // width: '100',
          // height: '100'
        })
        // window.UE.getEditor(this.idForEditor).execCommand('inserthtml', `<img src="${res[0].file_url}">`)
      })
    },
    createUe () {
      this.editor = new window.UE.ui.Editor(this.config)
      this.editor.render(this.idForEditor)
      // this.editor.render(this.idForEditor)
      // this.editor = window.UE.getEditor(this.idForEditor, this.config)
      this.editor.addListener('blur', (editor) => { this.ueblurGetContent() })
      this.editor.addListener('ready', (editor) => { this.ueready() })
      this.editor.addListener('beforepaste', (type, e) => {
        tool.pastePicture(e, this.$bus)
      })
    },
    // 表情解析
    traverseEmoji (params) {
      const plist = {'dict': [{'key': '[呲牙]', 'string': '1'}, {'key': '[调皮]', 'string': '2'}, {'key': '[汗]', 'string': '3'}, {'key': '[偷笑]', 'string': '4'}, {'key': '[拜拜]', 'string': '5'}, {'key': '[打你]', 'string': '6'}, {'key': '[擦汗]', 'string': '7'}, {'key': '[猪头]', 'string': '8'}, {'key': '[玫瑰]', 'string': '9'}, {'key': '[流泪]', 'string': '10'}, {'key': '[快哭了]', 'string': '11'}, {'key': '[嘘]', 'string': '12'}, {'key': '[酷]', 'string': '13'}, {'key': '[抓狂]', 'string': '14'}, {'key': '[委屈]', 'string': '15'}, {'key': '[屎]', 'string': '16'}, {'key': '[炸弹]', 'string': '17'}, {'key': '[菜刀]', 'string': '18'}, {'key': '[可爱]', 'string': '19'}, {'key': '[色]', 'string': '20'}, {'key': '[害羞]', 'string': '21'}, {'key': '[得意]', 'string': '22'}, {'key': '[吐]', 'string': '23'}, {'key': '[微笑]', 'string': '24'}, {'key': '[发火]', 'string': '25'}, {'key': '[尴尬]', 'string': '26'}, {'key': '[惊恐]', 'string': '27'}, {'key': '[冷汗]', 'string': '28'}, {'key': '[心]', 'string': '29'}, {'key': '[嘴唇]', 'string': '30'}, {'key': '[白眼]', 'string': '31'}, {'key': '[傲慢]', 'string': '32'}, {'key': '[难过]', 'string': '33'}, {'key': '[惊讶]', 'string': '34'}, {'key': '[疑问]', 'string': '35'}, {'key': '[睡]', 'string': '36'}, {'key': '[亲亲]', 'string': '37'}, {'key': '[憨笑]', 'string': '38'}, {'key': '[爱情]', 'string': '39'}, {'key': '[衰]', 'string': '40'}, {'key': '[撇嘴]', 'string': '41'}, {'key': '[奸笑]', 'string': '42'}, {'key': '[奋斗]', 'string': '43'}, {'key': '[发呆]', 'string': '44'}, {'key': '[右哼哼]', 'string': '45'}, {'key': '[抱抱]', 'string': '46'}, {'key': '[坏笑]', 'string': '47'}, {'key': '[企鹅亲]', 'string': '48'}, {'key': '[鄙视]', 'string': '49'}, {'key': '[晕]', 'string': '50'}, {'key': '[大兵]', 'string': '51'}, {'key': '[拜托]', 'string': '52'}, {'key': '[强]', 'string': '53'}, {'key': '[垃圾]', 'string': '54'}, {'key': '[握手]', 'string': '55'}, {'key': '[胜利]', 'string': '56'}, {'key': '[抱拳]', 'string': '57'}, {'key': '[枯萎]', 'string': '58'}, {'key': '[米饭]', 'string': '59'}, {'key': '[蛋糕]', 'string': '60'}, {'key': '[西瓜]', 'string': '61'}, {'key': '[啤酒]', 'string': '62'}, {'key': '[瓢虫]', 'string': '63'}, {'key': '[勾引]', 'string': '64'}, {'key': '[哦了]', 'string': '65'}, {'key': '[手势]', 'string': '66'}, {'key': '[咖啡]', 'string': '67'}, {'key': '[月亮]', 'string': '68'}, {'key': '[匕首]', 'string': '69'}, {'key': '[发抖]', 'string': '70'}, {'key': '[菜]', 'string': '71'}, {'key': '[拳头]', 'string': '72'}]
      }
      const emojiUrl = '@/../static/img/emoji/'
      let list = plist.dict
      for (var i = 0; i < list.length; i++) {
        params = params.replace(new RegExp('\\' + list[i].key, 'ig'), '<img class="emojiImg" src="' + emojiUrl + list[i].string + '.gif">')
      }
      return params
    },
    ueblurGetContent () {
      // 传递编辑器内容给父组件
      let html = this.editor.getContent()
      html = this.regSubstring(html)
      html = html.replace(/"/g, '\'') // 将双引号改为单引号，避免项目自动化json解析报错
      this.$bus.$emit('editorContents', html, this.moduleId)
      this.$bus.$emit('getContentTxt', this.editor.getContentTxt(), this.moduleId)
      this.$emit('input', this.editor.getContent())
    },
    ueready () {
      var that = this
      that.editorContentProp = that.traverseEmoji(that.editorContentProp || '')
      that.editor.execCommand('inserthtml', that.htmlChange(that.editorContentProp))
      if (that.isEdit) {
        that.editor.setEnabled() // 控制可编辑
      } else {
        that.editor.setDisabled() // 控制不可编辑
      }
    },
    regSubstring (element) { // 去掉最后无用的空格
      let newhtml = element
      let repeatEditor = function (html) {
        let length = html.length
        let index = html.lastIndexOf('<p><br/></p>')
        if (index !== -1 && length - index === 12) {
          newhtml = html.substring(0, index)
          repeatEditor(newhtml)
        }
      }
      repeatEditor(element)
      return newhtml
    },
    // html转换转义符
    htmlChange (data) {
      let newData = typeof (data) === 'string' ? (data.replace(data ? /&(?!#?\w+;)/g : /&/g, '&amp;').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "\\'")) : data
      return newData
    }
  },
  watch: {
    editorContent () {
      this.editorContentProp = this.editorContent
      this.editorContentProp = this.traverseEmoji(this.editorContentProp || '')
      // this.editor.execCommand('inserthtml', this.htmlChange(this.editorContentProp))
      this.editor.setContent(this.htmlChange(this.editorContentProp))
    }
  },
  destroyed () {
    // 将editor进行销毁
    window.UE.delEditor(this.idForEditor)
  }
}
</script>

<style lang="scss">
  .edui-default .edui-colorpicker-nocolor {
    height: auto !important;
  }
  .mail-ueditor{
    width: 100%;
    position: relative;
    .edui-editor {
      z-index: 9 !important;
    }
    .teamface-ueditor{
      display: none;
      // opacity: 0;
    }
    .edui-editor-iframeholder {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/components/ueditor.vue